/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendlyDemoLink } from '../../models/calendly-demo-link';

export interface GetCalendlyDemoLink$Params {
  phoneReference: string;
  contactReference: string;
}

export function getCalendlyDemoLink(http: HttpClient, rootUrl: string, params: GetCalendlyDemoLink$Params, context?: HttpContext): Observable<StrictHttpResponse<CalendlyDemoLink>> {
  const rb = new RequestBuilder(rootUrl, getCalendlyDemoLink.PATH, 'get');
  if (params) {
    rb.path('phoneReference', params.phoneReference, {});
    rb.path('contactReference', params.contactReference, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CalendlyDemoLink>;
    })
  );
}

getCalendlyDemoLink.PATH = '/v1/api/ui/calendly-demo/link/{phoneReference}/{contactReference}';
